console.log('✅ header-shop.js loaded successfully!');

import { APP_CONFIG } from '../../js/config.js';
import { appState, watchAppState, setNestedAppStateValueByKey } from '../../js/state.js';

import { registerEventListenerToAttach } from '../../js/to-attach-event-listener-registry.js';
import { debounceShared } from '../../js/utils-debounce.js';
import { addListenerViaCurrentlyAttachedListenersRegistry } from '../../js/currently-attached-listener-registry.js';

import {  isNodeEnvironment} from '../../js/utils-fetch-data-json.js';
import {
  convertStringAmountToCurrencyAndSignDirectionForLanguage,
  getCurrencyCultureSymbolOnLeftOrRight,
} from '../../js/utils-convert-currency.js';
import { loadTextTranslations } from '../../js/translator.js';
import { initLinksTranslator } from '../../js/router-routes-manager.js';
import { navigateTo } from '../../js/router-navigator.js';
import {
  fetchAllWishListItems,
  fetchRemoveItemFromWishList,
  fetchAllShoppingCartItemsLightForTopCart,
} from '../../services/data-services/shopping-cart-data-service.js';
import { initComponentHomePageResponsiveSidebar } from '../sidebars/home-page-responsive-sidebar.js';

// flags to remember whether each menu is open
let isCartOpen = false;
let isWishOpen = false;

export async function buildComponentHeaderShop() {
  console.log(
    `🔄 Building Component: buildComponentHeaderShop - lang: ${appState.SiteLanguageCookie}`
  );

  try {
    let htmlToRender = '';

    if (isNodeEnvironment()) {
      htmlToRender = await buildActualContent();
    } else {
      //required for main view so no skeleton
      //htmlToRender = await buildPageSkeleton();

      htmlToRender = await buildActualContent();
    }

    const html = `
      
    ${htmlToRender}
          
        `;

    console.log('✅ buildComponentHeaderShop built successfully.');

    // // Register event listeners
    // // registerEventListenerToAttach(attachEventListenersCatalogProducts);

    // Register event listeners
    //   registerEventListenerToAttach(()=> attachEventListenersHeaderShop(linkSearch));
    registerEventListenerToAttach(async () => initComponentHeaderShop());

    return html;
  } catch (err) {
    console.error('❌ Error building buildComponentHeaderShop:', err);
    return '<div>Error loading buildComponentHeaderShop </div>';
  }
}

export async function buildPageSkeleton() {
  //  // Top two “featured” cards
  //  const topCardsSkeletonHtml = `
  //    <br />
  //  <div class="grid-blog-home-bottom-section-card my-fake-image-height-250">
  //      <div class="my-site-lazy-loading-card">
  //          <div class="my-site-lazy-loading-card-movement"></div>
  //      </div>
  //  </div>
  //`;

  //  const topCardsSkeletonHtml2 = `
  //  <div class="grid-blog-category-home-featured-top-card my-fake-image-height-400">
  //      <div class="my-site-lazy-loading-card">
  //          <div class="my-site-lazy-loading-card-movement"></div>
  //      </div>
  //  </div>
  //  `;

  //  let middleCardsSkeleton = '';
  //  for (let i = 0; i < 4; i++) {
  //      middleCardsSkeleton += `
  //    <div class="grid-blog-home-featured-middle-section-card my-fake-image-height-400">
  //                                  <div class="my-site-lazy-loading-card">
  //                                      <div class="my-site-lazy-loading-card-movement"></div>
  //                                  </div>
  //                              </div>

  //  `;
  //  }

  //  // Sidebar section: repeat 5 times
  //  let sideBarCardsSkeleton = '  <br>  <br>';
  //  for (let i = 0; i < 5; i++) {
  //      sideBarCardsSkeleton += `
  //              <div class="grid-blog-home-bottom-section-card my-fake-image-height-125">
  //                          <div class="my-site-lazy-loading-card">
  //                              <div class="my-site-lazy-loading-card-movement"></div>
  //                          </div>
  //                      </div>

  //                      <br />

  //  `;
  //  }

  //  // Middle section: repeat 6 times
  //  let bottomCardsSkeleton = '';
  //  for (let i = 0; i < 6; i++) {
  //      bottomCardsSkeleton += `
  //   <div class="grid-blog-home-bottom-section-card my-fake-image-height-400">
  //                      <div class="my-site-lazy-loading-card">
  //                      <div class="my-site-lazy-loading-card-movement"></div>
  //                  </div>
  //              </div>
  //  `;
  //  }

  const html = `
    <div id="placeholder-buildComponentHeaderShop">
  
   

         </div>
    
   
  `;

  return html;
}

export async function buildActualContent() {
  console.log(`🔄 Building Component: HeaderShop - lang: ${appState.SiteLanguageCookie}`);

  try {
    // so it ends up in its own "translation-service" chunk:
    const { loadMyTranslationsService } = await import(
      /* webpackChunkName: "translation-service" */
      /* webpackPrefetch: true */
      '../../services/my-translator-service.js'
    );

    // 1) Load translations in parallel (cached after first call)
    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
      appState.SiteLanguageCookie
    );

    const {
      keySearch: lblSearch,
      keyDashboard: lblDashboard,
      keyWishlist: lblWishlist,
      keyCart: lblCart,
    } = _tempTextTranslator;

    const {
      keyMyMessages: linkMyMessages,
      keyDashboard: linkDashboard,
      keyWishlist: linkWishlist,
      keySearch: linkSearch,
      keyCart: linkCart,
    } = _tempLinksTranslator;

    const { buildComponentHomePageResponsiveSidebar } = await import(
      /* webpackChunkName: "home-page-responsive-sidebar" */
      /* webpackPrefetch: true */
      '../sidebars/home-page-responsive-sidebar.js'
    );

    // const sidebarHTML = "";

    const sidebarHTML = await buildComponentHomePageResponsiveSidebar();

    // alert("1 attaching event listeners to omePageResponsiveSidebar");
    // alert(sidebarHTML);

    const wishListHTML = await renderWishListHTML();

    const shoppingCartHTML = await renderShoppingCartHTML();

      const html = `
    <center>
    <div class="grid-header-wrapper">

      <!-- sidebar toggle for mobile -->
      <div class="mytoggleIcons">       
        ${sidebarHTML}
      </div>


      <!-- logo -->
      <div class="myLogo">
        <a href="/"><img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/logo/logo.jpg" alt="Logo" width="274" height="76" class="logo-Image"/></a>
      </div>



      <!-- search box -->
      <div class="mySearch">
       

        <table class="myTestSearchTextBox-Table">
            <tr class="myTestSearchTextBox-Table-Row">


                <td class="myTestSearchTextBox-Cell-Search">
                    <input id="searchInput" type="search" placeholder="${lblSearch}"  />
                </td>
                <td class="myTestSearchTextBox-Cell-SearchBtn">
                    <button id="searchButton" class="myTestSearchTextBox-Btn" type="button" aria-label="${lblSearch}" alt="start search" >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
                            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"></path>
                        </svg>
                    </button>
                </td>
            </tr>
        </table>


      </div>


      <!-- account, wishlist, cart icons -->
      <div class="myCartIcons">
        
         <table>
            <tr>
                <td>



                    <div class="NewTopShoppingCartAndAccountICONSBasket">
                        <div class="myTopIconsButtonsButLink">
                            <a href="${linkDashboard}">
                                <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/png/avatar-icon.png" title="My Account" alt="Avatar" width="50" height="50" class="myTopIconsButtonsMainImg" />
                                </a>
                            <span class="badgeTopAvatar" id="BadgeTopAvatar">
                                <a href="${linkMyMessages}" title="My Messages">  

                                 
                                 <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="">
      <path d="M1.60175 4.20114C2.14997 3.47258 3.02158 3 4 3H20C20.9784 3 21.85 3.47258 22.3982 4.20113L12 11.7635L1.60175 4.20114Z" fill="#fff"/>
      <path d="M1 6.2365V18C1 19.6523 2.34772 21 4 21H20C21.6523 21 23 19.6523 23 18V6.23649L13.1763 13.381C12.475 13.891 11.525 13.891 10.8237 13.381L1 6.2365Z" fill="#fff"/>
    </svg>
                                </a>
                            </span>
                        </div>
                    </div>
                </td>



                <td>
                <div class="NewTopShoppingCartAndAccountICONSBasket">

                 ${wishListHTML}

                 


  </div>
                </td>



                <td>
                <div class="NewTopShoppingCartAndAccountICONSBasket">

                 ${shoppingCartHTML}


               

                              </div>
                </td>



                </tr>
                </table>
      </div>
    </div>
    </center>

    `;

 //     html += `

 //    MyLoggedInUserID ${appState.MyLoggedInUserID} <br> 
 //MyBuyingEntityID ${appState.MyBuyingEntityID} <br> 
 //MyBuyingEntityType ${appState.MyBuyingEntityType}</h6>

 // `;

    console.log('✅ HeaderShop built successfully.');

    return html;
  } catch (err) {
    console.error('❌ Error building HeaderShop:', err);
    return '<div>Error loading shop header </div>';
  }
}

export async function initComponentHeaderShop() {
  // function attachEventListenersHeaderShop(linkSearch) {
  console.log('✅ HeaderShop event listeners attached.');

  // alert("attachEventListenersHeaderShop called");

  try {
    // required for main view so no skeleton

    //let htmlToRender = await buildActualContent();
    //const currentPlacholder = document.querySelector("#placeholder-buildComponentHeaderShop");
    //if (currentPlacholder) {
    //    currentPlacholder.innerHTML = htmlToRender;
    //}

    const { initComponentHomePageResponsiveSidebar } = await import(
      /* webpackChunkName: "home-page-responsive-sidebar" */
      /* webpackPrefetch: true */
      '../sidebars/home-page-responsive-sidebar.js'
    );

    await initComponentHomePageResponsiveSidebar();

    // so it ends up in its own "translation-service" chunk:
    const { loadMyTranslationsService } = await import(
      /* webpackChunkName: "my-translator-service" */
      /* webpackPrefetch: true */
      '../../services/my-translator-service.js'
    );

    // 1) Load translations in parallel (cached after first call)
    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
      appState.SiteLanguageCookie
    );

    const { keyRecentArticles: lblRecentArticles } = _tempTextTranslator;

    const { keySearch: linkSearch } = _tempLinksTranslator;

    // alert("attachEventListenersHeaderShop called");
    // console.log("attachEventListenersHeaderShop called"); }
    // alert("attachEventListenersHeaderShop called");

    await setupSearchInputAndButtonListeners(linkSearch);

    setupCartDropdownToggle();

    setupWishlistDropdownToggle();

    await setupRemoveItemFromWishlistButtons();

    await setupShoppingCartGoToCartButton();

    await setupCloseOnListingLinkClick();

    // ➊ Listen globally for clicks…
    document.removeEventListener('click', onDocumentClick);
    document.addEventListener('click', onDocumentClick);

    ////// Close dropdown when clicking outside
    ////document.addEventListener("click", (event) => {
    ////    if (!dropdown.contains(event.target) && !shipToCountryButton.contains(event.target)) {
    ////        closeDropdown();
    ////    }
    ////});

    console.log('✅ HeaderShop listeners attached.');
  } catch (err) {
    console.error('❌ Error attaching HeaderShop listeners:', err);
  }
}

function onDocumentClick(event) {
  const cartBtn = document.getElementById('btnCartToggle');
  const cartMenu = document.getElementById('cartDropdown');
  const wishBtn = document.getElementById('btnWishlistToggle');
  const wishMenu = document.getElementById('wishListDropdown');

  // if click is outside cart button & menu, close cart
  if (
    isCartOpen &&
    cartMenu &&
    cartBtn &&
    !cartMenu.contains(event.target) &&
    !cartBtn.contains(event.target)
  ) {
    handleCartToggle();
  }

  // if click is outside wish button & menu, close wishlist
  if (
    isWishOpen &&
    wishMenu &&
    wishBtn &&
    !wishMenu.contains(event.target) &&
    !wishBtn.contains(event.target)
  ) {
    handleWishlistToggle();
  }
}

async function handleSearch(query, linkSearch) {
  //if (query.length === 0) {
  //    alert("Please enter a search query.");
  //    console.log("No search query entered.");
  //    return;
  //}
  // console.log("Running search for:", query);
  // TODO: Insert your real search logic here

  //const q = document.getElementById("hdr-search-input").value.trim();
  //if (!q) return;

  // window.location.href = `${linkSearch}?search=${encodeURIComponent(query)}`;

  navigateTo(`${linkSearch}?search=${encodeURIComponent(query)}`);
}

async function setupSearchInputAndButtonListeners(linkSearch) {
  const input = document.getElementById('searchInput');
  const button = document.getElementById('searchButton');
  if (!input || !button) return;

  // Create named handlers scoped to the current linkSearch
  const onSearchInputKeydown = async function(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      await handleSearch(input.value.trim(), linkSearch);
    }
  };

  const onSearchButtonClick = async function() {
    await handleSearch(input.value.trim(), linkSearch);
  };

  // Remove existing handlers first to prevent stacking
  input.removeEventListener('keydown', onSearchInputKeydown);
  button.removeEventListener('click', onSearchButtonClick);

  // Add fresh handlers
  input.addEventListener('keydown', onSearchInputKeydown);
  button.addEventListener('click', onSearchButtonClick);
}

//async function setupSearchInputAndButtonListeners(linkSearch) {

//   // alert("setupSearchInputAndButtonListeners called");

//    const input = document.getElementById("searchInput");
//    const button = document.getElementById("searchButton");
//    if (!input || !button) return;

//    // Replace clones to clean up any old event handlers
//    const inputClone = input.cloneNode(true);
//    const buttonClone = button.cloneNode(true);
//    input.parentNode.replaceChild(inputClone, input);
//    button.parentNode.replaceChild(buttonClone, button);

//    // ENTER key on search input
//    addListenerViaCurrentlyAttachedListenersRegistry(inputClone, "keydown", async (event) => {
//        if (event.key === "Enter") {
//            event.preventDefault(); // prevent form submit if needed
//            await handleSearch(inputClone.value.trim(), linkSearch);
//        }
//    });

//    // CLICK on search button
//    addListenerViaCurrentlyAttachedListenersRegistry(buttonClone, "click", async () => {
//        await handleSearch(inputClone.value.trim(), linkSearch);
//    });
//}

function setupCartDropdownToggle() {
  const btn = document.getElementById('btnCartToggle');
  if (!btn) return;

  // Safely remove existing listener (if any)
  btn.removeEventListener('click', handleCartToggle);

  // Add fresh listener
  btn.addEventListener('click', handleCartToggle);
}

//async function setupCartDropdownToggle() {

//    const btn = document.getElementById("btnCartToggle");
//    if (!btn) return;

//    const clone = btn.cloneNode(true);
//    btn.parentNode.replaceChild(clone, btn);

//    addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//        await handleCartToggle();
//    });
//}

function setupWishlistDropdownToggle() {
  const btn = document.getElementById('btnWishlistToggle');
  if (!btn) return;

  // Safely remove existing listener (if any)
  btn.removeEventListener('click', handleWishlistToggle);

  // Add fresh listener
  btn.addEventListener('click', handleWishlistToggle);
}

//async function setupWishlistDropdownToggle() {
//    const btn = document.getElementById("btnWishlistToggle");
//    if (!btn) return;

//    const clone = btn.cloneNode(true);
//    btn.parentNode.replaceChild(clone, btn);

//    addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {
//        await handleWishlistToggle();
//    });
//}

async function handleCartToggle() {
  // alert("handleCartToggle called");
  const dropdown = document.getElementById('cartDropdown');
  if (!dropdown) return;
  isCartOpen = !isCartOpen;
  dropdown.style.display = isCartOpen ? 'block' : 'none';
}

async function handleWishlistToggle() {
  const dropdown = document.getElementById('wishListDropdown');
  if (!dropdown) return;
  isWishOpen = !isWishOpen;
  dropdown.style.display = isWishOpen ? 'block' : 'none';
}

async function handleCloseCart() {
  const dropdown = document.getElementById('cartDropdown');
  if (!dropdown) return;
  isCartOpen = false;
  dropdown.style.display = 'none';
}

//Since each button needs its own skuid, define a factory function that returns the properly scoped handler.
function createRemoveWishlistItemHandler(skuID) {
  return async function onRemoveWishlistItemClick(event) {
    event.preventDefault();
    await fetchRemoveItemFromWishList(skuID);
  };
}

export async function setupRemoveItemFromWishlistButtons() {
  const buttons = document.querySelectorAll('.btnRemoveWishListItem');
  if (!buttons.length) return;

  buttons.forEach(button => {
    const skuID = button.getAttribute('data-skuid');
    const handler = createRemoveWishlistItemHandler(skuID);

    // Prevent duplicate stacking
    button.removeEventListener('click', handler);

    // Add fresh listener
    button.addEventListener('click', handler);
  });
}

//async function setupRemoveItemFromWishlistButtons() {
//    const buttons = document.querySelectorAll(".btnRemoveWishListItem");
//    if (!buttons) return;
//    buttons.forEach(button => {
//        const clone = button.cloneNode(true);
//        button.parentNode.replaceChild(clone, button);
//        addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async (event) => {
//            event.preventDefault();
//            const skuID = event.target.getAttribute("data-skuid");

//            await fetchRemoveItemFromWishList(skuID);
//        });
//    });
//}

export async function setupShoppingCartGoToCartButton() {
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "my-translation-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  const { _tempLinksTranslator } = await loadMyTranslationsService(appState.SiteLanguageCookie);
  const { keyShoppingCart: linkShoppingCart } = _tempLinksTranslator;

  const button = document.getElementById('btnShoppingCartGoToCart');
  if (!button) return;

  // Named handler that captures the resolved link
  const onGoToCartClick = async function() {
    navigateTo(linkShoppingCart);
    handleCloseCart();
  };

  // Safely remove any existing instances
  button.removeEventListener('click', onGoToCartClick);

  // Add the fresh handler
  button.addEventListener('click', onGoToCartClick);
}

export async function setupCloseOnListingLinkClick() {
  const links = document.querySelectorAll('.ItemRowInTopCartTable .ItemRowInTopCartRow a');

  if (!links.length) return;

  links.forEach(link => {
    // Safely remove any existing instances
    link.removeEventListener('click', handleCloseCart);
    // Add the fresh handler
    link.addEventListener('click', handleCloseCart);
  });
}

//async function setupShoppingCartGoToCartButton() {

//  //  alert("setupShoppingCartGoToCartButton called");

//    // so it ends up in its own "translation-service" chunk:
//    const { loadMyTranslationsService } = await import(
//        /* webpackChunkName: "translation-service" */
//        /* webpackPrefetch: true */
//        "../../services/my-translator-service.js"
//    );

//    // 1) Load translations in parallel (cached after first call)
//    const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(appState.SiteLanguageCookie);

//    const {
//        keyShoppingCart: linkShoppingCart,
//    } = _tempLinksTranslator;

//    const button = document.getElementById("btnShoppingCartGoToCart");
//    if (!button) {
//       // alert("btnShoppingCartGoToCart not found");
//        return;
//    }
//    else {
//       // alert("btnShoppingCartGoToCart found");
//    }

//    const clone = button.cloneNode(true);
//    button.parentNode.replaceChild(clone, button);
//    addListenerViaCurrentlyAttachedListenersRegistry(clone, "click", async () => {

//        navigateTo(linkShoppingCart);
//    });

//}

async function renderWishListHTML() {
  const wishListData = await fetchAllWishListItems();

  const countOfItems = wishListData.length;

  // it count is 0, then hide the badge and if it is greater than 99 show +99
  const badgeCount = countOfItems > 99 ? '+99' : countOfItems;
  const badgeStyle = countOfItems === 0 ? 'display: none;' : 'display: inline-block;';

  const wishListItems = await renderWishListItemsRows(wishListData);

  const html = ` <button id="btnWishlistToggle" type="button" class="myTopIconsButtons">
                             <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/png/wishlist-icon.png" title="Wishlist" alt="Wishlist" width="50" height="50" class="myTopIconsButtonsMainImg">

                            
                                <span class="badgeTopWishList" id="BadgeTopWishList" style="${badgeStyle}">${badgeCount}</span>
                            

                        </button>

                        <div id="wishListDropdown" class="WishListTopSummaryWrapper">


                            <div id="TopShoppingWishListItemsContainer">
                           ${wishListItems}
                            </div>
                            </div>`;

  return html;
}

async function renderShoppingCartHTML() {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "translation-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  const { keyTotal: lblTotal, keyViewCartNCheckout: lblViewCartNCheckout } = _tempTextTranslator;

  const shoppingCartItemsData = await fetchAllShoppingCartItemsLightForTopCart();

  const countOfItems = shoppingCartItemsData.length;

  // it count is 0, then hide the badge and if it is greater than 99 show +99
  const badgeCount = countOfItems > 99 ? '+99' : countOfItems;
  const badgeStyle = countOfItems === 0 ? 'display: none;' : 'display: inline-block;';

  const shoppingCartItems = await renderShoppingCartItemsRows(shoppingCartItemsData);

  const totalAmountToDisplay = convertStringAmountToCurrencyAndSignDirectionForLanguage(
    shoppingCartItemsData.reduce((acc, item) => acc + item.subTotal, 0),
    appState.SiteLanguageCookie,
    appState.SiteCurrencySignSingleCookie,
    appState.SiteCurrencySignMultipleCookie
  );

  const html = ` 


                               <button id="btnCartToggle" type="button" class="myTopIconsButtons">
                             <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/png/shopping-cart-icon.png" title="Shopping Cart" alt="Shopping Cart" width="50" height="50" class="myTopIconsButtonsMainImg">

                            <span class="badgeTopCart" id="BadgeTopCart" >${badgeCount}</span>

                        </button>

                             <div id="cartDropdown" class="cartTopSummaryWrapper">


                            <div id="cartTopSummaryWrapperheaderWrapper">
                              <div class="cartTopSummaryWrapperheaderContainer">

                                    <div class="Topcart-icon">   
                                        <img src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/png/shopping-cart-icon.png" width="50" height="50" alt="Shopping Cart"/>
                                     </div>


                                    <div class="TopShopping-cart-total">

                                        <span class="lighter-text">${lblTotal}:</span>
                                        <span class="main-color-text"> ${totalAmountToDisplay} </span>

                                    </div>

                                </div>
                            </div>

                           <div id="TopShoppingCartItemsContainer">

                                <div class="ItemRowInTopCartTable">
                             ${shoppingCartItems}
                             </div>
                            </div>


                             <button id="btnShoppingCartGoToCart" class="topCartbutton">${lblViewCartNCheckout}</button>

                            </div>



                            `;

  return html;
}

async function renderWishListItemsRows(wishListData) {
  // Map each row → HTML
  const itemsHtml =
    wishListData.length === 0
      ? `<div class="TopWishListitem-empty">Your Wishlist is empty.</div>`
      : wishListData
          .map(row => {
            const skuReturnLinkPath = `/${appState.SiteLanguageCookie}/${row.departmentID}/${row.departmentSEOPageName}/${row.categoryID}/${row.categorySEOPageName}/${row.productID}/${row.productSEOPageName}/${row.listingID}/${row.skuid}/${row.listingSEOPageName}`;

            return `
          <div class="ItemRowInTopWishListRow">
            <div class="ItemRowInTopWishListRow-Div">
              <div class="ItemRowInTopWishListCell-Delete">
                <img
                  src="${APP_CONFIG.IMAGES_BASE_URL}imgs/icons/svg/trash1.svg"
                  class="btnRemoveWishListItem"
                  data-skuid="${row.skuid}"
                  />
              </div>
              <div class="ItemRowInTopWishListCellImage">
                <div class="TopSummaryWishListImgContainer">
                  <a href="${skuReturnLinkPath}" class="closeWishListDropdown">
                    <img src="${row.image1FileName}" alt="${row.listingName}" />
                  </a>
                </div>
              </div>
              <div class="ItemRowInTopWishListCellDescription">
                <a href="${skuReturnLinkPath}" class="closeWishListDropdown">
                  <span class="TopWishListitem-name">${row.listingName}</span>
                </a>
              </div>
            </div>
          </div>
        `;
          })
          .join('');

  return itemsHtml;
}

async function renderShoppingCartItemsRows(shoppingCartData) {
  // so it ends up in its own "translation-service" chunk:
  const { loadMyTranslationsService } = await import(
    /* webpackChunkName: "translation-service" */
    /* webpackPrefetch: true */
    '../../services/my-translator-service.js'
  );

  // 1) Load translations in parallel (cached after first call)
  const { _tempTextTranslator, _tempLinksTranslator } = await loadMyTranslationsService(
    appState.SiteLanguageCookie
  );

  const { keyQuantity: lblQuantity } = _tempTextTranslator;

  // Map each row → HTML
  const itemsHtml = shoppingCartData
    .map(row => {
      const skuReturnLinkPath = `/${appState.SiteLanguageCookie}/${row.departmentID}/${row.departmentSEOPageName}/${row.categoryID}/${row.categorySEOPageName}/${row.productID}/${row.productSEOPageName}/${row.listingID}/${row.skuid}/${row.listingSEOPageName}`;

      const subTotalDisplay = convertStringAmountToCurrencyAndSignDirectionForLanguage(
        row.subTotal,
        appState.SiteLanguageCookie,
        appState.SiteCurrencySignSingleCookie,
        appState.SiteCurrencySignMultipleCookie
      );

      return `



                                        <div class="ItemRowInTopCartRow">

                                            <a href="${skuReturnLinkPath}">
                                                <div class="ItemRowInTopCartCellImage">
                                                    <div class="TopSummarycartImgContainer">
                                                          <img src="${row.image1FileName}" alt="${row.listingName}" width="70" height="70" />

                                                    </div>
                                                </div>

                                                <div class="ItemRowInTopCartCellDescription">


                                                    <span class="TopCartitem-name">${row.listingName}  </span>



                                                    <div class="TopSummarycartDetailsTable">



                                                        <div class="TopSummarycartDetailsRow">
                                                            <div class="TopSummarycartDetailsCell">

                                                                <span class="TopCartitem-quantity">${lblQuantity}: ${row.skuQuantity}  </span>
                                                            </div>
                                                        </div>
                                                        <div class="TopSummarycartDetailsRow">

                                                            <div class="TopSummarycartDetailsCell">

                                                                <span class="TopCartitem-price">  ${subTotalDisplay} </span>
                                                            </div>

                                                        </div>





                                                    </div>

                                                </div>
                                            </a>
                                        </div>




          
        `;
    })
    .join('');

  return itemsHtml;
}




async function refreshWholeComponent(isAuthenticated) {

 //   alert(`updateHeaderForUser called with isAuthenticated: ${isAuthenticated}`);

    await buildComponentHeaderShop();
    await initComponentHeaderShop();

   
}


let IsAttachedWatchAppState = false;

if (!IsAttachedWatchAppState) {
    watchAppState('MyUserIsAuthenticated', refreshWholeComponent);
    IsAttachedWatchAppState = true;
}
